<template>
  <div id="app">
	<HeaderPart></HeaderPart>
	<router-view/>
	<FooterPart></FooterPart>
  </div>
</template>

<script>
import HeaderPart from './components/HeaderPart.vue'
import FooterPart from './components/FooterPart.vue'

export default {
  name: 'App',
  components: {
    HeaderPart,
	FooterPart
  },
  data() {
  	return {
		
  	}
  },
  mounted() {
	  
  },
  methods: {
	  
  }
}


</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
</style>
